
































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import axiosInstance from '@/plugins/axios'
import { showHttpErrorAlert } from '@/plugins/helper'
import dayjs from 'dayjs'
import AppNavDrawer from '@/components/AppNavDrawer.vue'

@Component({
  components: {
    AppNavDrawer
  }
})
export default class PageViewOrderDetail extends Vue {
  orderDetailHeaders = [
    { text: 'Group Name', value: 'package_group_name_en' },
    { text: 'Package Name', value: 'package_name_en' },
    { text: 'Protection Limit', value: 'package_protection_limit' },
    { text: 'Price', value: 'package_price' }
  ]

  created () {
    this.fetchOrder()
  }

  order = null

  async fetchOrder () {
    try {
      // TODO: handle not found insurance
      const { data } = await axiosInstance.get(`/portal/insurance/orders/${this.$route.params.insuranceCode}`)
      this.order = data
    } catch (error) {
      showHttpErrorAlert(error)
    }
  }

  formatDate (date: string, format: string): string {
    return dayjs(date).format(format)
  }
}
